import {useCompany} from "../../core";
import {getAmProjectConfig, isICP4Namespace} from "../../ps-models";
import { FourthPartnerProjectSync } from './FourthPartner/FourthPartnerProjectSync';
import { ICP4ProjectSyncing } from '../icp4/ICP4ProjectSyncing';

export function ProjectSync() {
  let company = useCompany();
  const { namespace } = getAmProjectConfig(company);

  if(isICP4Namespace(namespace)){
    return <ICP4ProjectSyncing />
  }

  return <FourthPartnerProjectSync />
}